import {
  type PimProductV11,
  type PimProductWithVariantsV1,
} from '@redteclab/api/clients/bully'

/**
 * Finds variant with same upid as product.
 */
export const productAccessorGetProductVariantForCurrentUpid = (
  product: PimProductWithVariantsV1,
): PimProductV11 => {
  const id = product.upid

  const variantToSet = product.variants.find((variant) => variant.upid === id)

  if (!variantToSet) {
    throw new Error('ProductPageContextProvider_NO_VARIANT_FOUND')
  }

  return variantToSet
}
